import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import sortBy from 'utils/sortBy';
import Text from 'components/Text';
import InlineList from 'components/InlineList';
import BulletList from 'components/BulletList';
import Flex from 'components/Flex';
import Stack from 'components/Stack';
import { AdminPill, EveryonePill, TeamPill } from 'components/Pill';
import PlaylistsTeamsDropdown from './PlaylistsTeamsDropdown';
export function useAudienceSummary(accessData) {
  return React.useMemo(function () {
    var audience = accessData.audience,
      audienceCalculated = accessData.audienceCalculated,
      teams = accessData.teams,
      parentPlaylists = accessData.parentPlaylists;
    var actualTeams = teams.filter(function (team) {
      return !team.isCalculated;
    });
    var calculatedTeams = teams.filter(function (team) {
      return team.isCalculated;
    });
    var requiredParentPlaylists = parentPlaylists.filter(function (playlist) {
      return !playlist.optional;
    });

    // Check if any teams were inherited
    var hasInheritedTeams = actualTeams.sort().toString() !== calculatedTeams.sort().toString();
    var hasEffectiveAudience = Boolean(requiredParentPlaylists.length) && (hasInheritedTeams || audience !== audienceCalculated);
    return {
      hasInheritedTeams: hasInheritedTeams,
      hasEffectiveAudience: hasEffectiveAudience,
      requiredParentPlaylists: requiredParentPlaylists,
      audienceCalculated: audienceCalculated,
      calculatedTeams: calculatedTeams
    };
  }, [accessData]);
}
function AudienceSummary(_ref) {
  var audienceSummary = _ref.audienceSummary,
    accessData = _ref.accessData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var hasInheritedTeams = audienceSummary.hasInheritedTeams,
    requiredParentPlaylists = audienceSummary.requiredParentPlaylists,
    audienceCalculated = audienceSummary.audienceCalculated,
    calculatedTeams = audienceSummary.calculatedTeams;
  var playlistsCount = requiredParentPlaylists.length;
  var summary = /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "playlist_access_who_can_see_this_info",
    count: playlistsCount
  }, "This playlist is set to required in", ' ', /*#__PURE__*/React.createElement(PlaylistsTeamsDropdown, {
    parentPlaylists: requiredParentPlaylists,
    playlist: accessData
  }, "count playlists"), "and inherits their audience.");
  var sortTeams = function sortTeams(teams) {
    return sortBy(teams, function (team) {
      return team.name.toLowerCase();
    });
  };
  return /*#__PURE__*/React.createElement(BulletList, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xxs"
  }, /*#__PURE__*/React.createElement(Flex, {
    flexDirection: "row",
    gap: "xs",
    flexWrap: "wrap"
  }, /*#__PURE__*/React.createElement(Text, null, t('playlist_access_effective_audience_title')), audienceCalculated === 'admin' && /*#__PURE__*/React.createElement(AdminPill, null), audienceCalculated === 'all' && /*#__PURE__*/React.createElement(EveryonePill, null), hasInheritedTeams && /*#__PURE__*/React.createElement(InlineList, {
    spacing: "xs"
  }, sortTeams(calculatedTeams).map(function (team) {
    return /*#__PURE__*/React.createElement(TeamPill, {
      key: team.id,
      team: team
    });
  }))), /*#__PURE__*/React.createElement(Text, null, summary)));
}
export default AudienceSummary;